import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {INotificacion, IParcela, woody_crops} from "../../../types";
import {Typography} from "@material-ui/core";
import {userService} from "../../../services/UserService";
import MapaRiego from "./MapaRiego";
import GraficoRiego from "./GraficoRiego";
import TablaRiego from "./TablaRiego";
import Pronostico from "./Pronostico";
import Historico from "./Historico";
import RiegoReal from "./RiegoReal";
import HistoricoRiego from "./HistoricoRiego";

const config = require('../../../config.json');
const texts = require('../../../texts/riegoneto.json')


interface IProps {
    notify(notification: INotificacion): void
    setRiego(riego: Record<string, Record<string, number>>): void
    setPronostico(pronostico: Record<string, Record<string, number>>): void
    setHistorico(historico: Record<string, Record<string, number>>): void
    menu: boolean
    riego: Record<string, Record<string, number>>
    pronostico: Record<string, Record<string, number>>
    historico: Record<string, Record<string, number>>
    metodo: string
    parcela: string
    parcelaProps: IParcela
    idioma: string
}

interface Istate {
    vertical: boolean
    cambiando: boolean
    text: Record<string, string>
}

class RiegoNeto extends React.Component<IProps, Istate> {

    state: Istate = {
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        const url: string = config.url+`/historico/tiempo?parcela=${this.props.parcela}`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                this.props.setHistorico(res.data)
            })
            .catch(() => {
                this.props.notify({message: 'Error interno al cargar datos de riego', variant: 'error'})
            })
    }


    render() {
        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }


        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false);

        if (Object.keys(this.props.riego).length === 0) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginLeft: this.props.menu? '18%': '5%',
                        width: this.props.menu? '72%': '95%',
                        height: '100%'
                    }}
                >
                </div>
            )

        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: '100%',
                        height: '100%',
                        backgroundColor: '#eee'
                    }}
                >
                    <link rel="stylesheet"
                          href="https://fonts.googleapis.com/css?family=Poppins"
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: '100%',
                            height: '100%',
                            overflow: "auto",
                            marginLeft: this.state.vertical? 5: 80,
                            marginRight: this.state.vertical? 10: 80
                        }}
                    >


                        <div
                            style={{
                                width: '95%',
                                height: this.state.vertical? '50%' : '65%',
                                marginTop: '5%'
                            }}
                        >
                            <MapaRiego/>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                width: '100%',
                                height: this.state.vertical? '50%' : '35%',
                            }}
                        >

                            {/*{woody_crops.includes(this.props.parcelaProps.cultivo) && this.props.metodo === 'satelital' &&*/}
                            {/*<div*/}
                            {/*    style={{*/}
                            {/*        backgroundColor: '#ff5b5b',*/}
                            {/*        borderRadius: 20,*/}
                            {/*        width: '95%',*/}
                            {/*        marginTop: 20*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    <Typography*/}
                            {/*        style={{*/}
                            {/*            display: "flex",*/}
                            {/*            flexDirection: "row",*/}
                            {/*            marginLeft: 30,*/}
                            {/*            marginRight: 30,*/}
                            {/*            alignItems: "center",*/}
                            {/*            fontFamily: "Poppins"*/}
                            {/*        }}*/}
                            {/*    >*/}
                            {/*        {this.state.text["0"]}*/}
                            {/*    </Typography>*/}
                            {/*</div>*/}
                            {/*}*/}

                            <div
                                style={{
                                    width: '95%',
                                    marginTop: 20
                                }}
                            >
                                <GraficoRiego/>
                            </div>

                            <div
                                style={{
                                    width: '95%',
                                    marginTop: 20
                                }}
                            >
                                <TablaRiego/>
                            </div>

                            <div
                                style={{
                                    width: '95%',
                                    marginTop: 20
                                }}
                            >
                                <Pronostico/>
                            </div>

                            <div
                                style={{
                                    width: '95%',
                                    marginTop: 20
                                }}
                            >
                                <RiegoReal/>
                            </div>

                            <div
                                style={{
                                    width: '95%',
                                    marginTop: 20
                                }}
                            >
                                <Historico/>
                            </div>

                            <div
                                style={{
                                    width: '95%',
                                    marginTop: 30
                                }}
                            >
                                <HistoricoRiego/>
                            </div>

                            <div
                                style={{
                                    width: '95%',
                                    marginTop: 20,
                                    height: 20,
                                    whiteSpace: "nowrap",
                                    color: '#eee'
                                }}
                            >
                                .
                            </div>

                        </div>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: '100%',
                            height: '100%',
                            overflow: "auto",
                            zIndex: this.props.menu ? 3 : -3,
                            marginLeft: '-100%',
                            backgroundColor: "rgba(0,0,0,0.6)"
                        }}
                    />

                </div>
            )
        }
    }
}

const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    riego: state.riego.riego,
    pronostico: state.riego.pronostico,
    historico: state.riego.historico,
    metodo: state.riego.metodo,
    parcela: state.navegacion.parcela,
    parcelaProps: state.riego.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setRiego: (riego: Record<string, Record<string, number>>) => dispatch({type: "set-riego-riego", riego}),
    setPronostico: (pronostico: Record<string, Record<string, number>>) => dispatch({type: "set-riego-pronostico", pronostico}),
    setHistorico: (historico: Record<string, Record<string, number>>) => dispatch({type: "set-riego-historico", historico})
});

export default connect(mapStateToProps, mapDispatchToProps)(RiegoNeto);
